import i18n from 'i18n/i18n';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'reducers/modal';
import { useTranslation } from 'react-i18next';
import JoytronIcon from 'assets/apply.clevry/Img_Robot_Joybuster.png';
import HourglassIcon from 'assets/apply.clevry/Icon_Hourglass.jpg';
import InfoIcon from 'assets/apply.clevry/Icon_Password_Info.png';
import { selectAssessmentName } from 'reducers/assessment';

type AssessmentLoadingAntiCheatingModalProps = {
  data: {
    timeoutFunction: () => void;
    overrideCloseModal?: boolean;
  };
};

export const AssessmentLoadingAntiCheatingModal: React.FC<
  AssessmentLoadingAntiCheatingModalProps
> = ({ data }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('Assessment+-+Countermeasures+Modal', { i18n });
  const assessmentName = useSelector(selectAssessmentName);

  useEffect(() => {
    setTimeout(() => handleTimeout(), 3400);
  }, []);

  const handleTimeout = () => {
    data.timeoutFunction();
    // if (!data.overrideCloseModal) {
    //   dispatch(closeModal());
    // }
  };

  const modalStyle = {
    '--modalTitleColor': '#036C8F',
    '--footerBackgroundColor': '#f5f5f5',
    '--footerBorderColor': '#f5f5f5',
    '--primaryButtonBackgroundColor': '#36705B',
    '--tertiaryButtonBackgroundColor': '#d5d5d5',
  } as React.CSSProperties;

  const currentWebskin = window.sessionStorage.getItem('webskin')
    ? window.sessionStorage.getItem('webskin')
    : 'defaultTheme';    

  return (
    <div className={"AssessmentModal AntiCheating" + 
      (assessmentName ? (' ' + assessmentName) : '') + 
      (currentWebskin !== 'defaultTheme' ? (' ' + currentWebskin) : '')
    } 
      style={modalStyle}
    >
      <div className="Content">
        <div className="MainIcon">
          <img src={JoytronIcon} alt={t('SSCandidate_Countermeasures_Modal_Alt_Joytron_Robot')} />
        </div>
        <h2>{t('SSCandidate_Countermeasures_Modal_Launching')}</h2>
        <div className="LoadingIcon">
          <img src={HourglassIcon} alt={t('SSCandidate_Countermeasures_Modal_Alt_Loading')} />
        </div>

        <div className="InfoContainer">
          {t('SSCandidate_Countermeasures_Modal_Whats_This')}
          <div className="MoreInfo">
            <img src={InfoIcon} alt={t('SSCandidate_Countermeasures_Modal_Alt_More_Info')} />
            <div className="Message">
              {t('SSCandidate_Countermeasures_Modal_Whats_This_Tooltip')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
